export { BenefitsSection } from './benefits-section';
export { ContactSection } from './contact-section';
export { FeaturesSection } from './features-section';
export { HeroSection } from './hero-section';
export { TestimonialsSection } from './testimonials-section';
